export const live = {
    zbz: "Ao Vivo",
    ljks: "Começar Agora",
    hmyzb: "Você ainda não fez nenhuma live~",
    zbyg: "Prévia da Live",
    yjs: "Finalizada",
    jszb: "Encerrar Live",
    gbzb: "Fechar Live",
    jxzb: "Continuar Live",
    bctp: "Salvar Imagem",
    fxlj: "Compartilhar Link",
    zbydk: "Live desconectada, aguarde...",
    fh: "Voltar",
    wjcdypsb: "Nenhum dispositivo de áudio detectado",
    czsb: "Falha na operação Canvas:",
    tpjzsb: "Falha ao carregar imagem, verifique se a URL está correta e a imagem está acessível",
    zbjl: "Histórico de Lives",
    sqjl: "Histórico de Solicitações",
    lts: "Sala de Chat",
    ren: "pessoas",
    gdcy: "Mais Membros",
    cy: "Membros",
    jcjy: "Remover Silêncio",
    jy: "Silenciar",
    qbjy: "Silenciar Todos",
    zbjs: "Introdução da Live",
    srnr: "Digite o conteúdo",
    tczbj: "Você foi removido da sala de live",
    qd: "Confirmar",
    zbjjjs: "Sua live terminará automaticamente em 10min!",
    zbsc: "Duração da Live:",
    ljgkrs: "Total de Visualizações:",
    dzs: "Curtidas:",
    zbjies: "Live Encerrada",
    ybjy: "Você foi silenciado",
    jycg: "Silêncio removido com sucesso",
    jinycg: "Silenciado com sucesso",
    qbjinycg: "Todos silenciados com sucesso",
    qbjycg: "Silêncio de todos removido com sucesso",
    cwzb: "Tornar-se Streamer",
    lxgzry: "Entre em contato com nossa equipe para se tornar um streamer",
    lxfs: "Formas de Contato",
    zb: "Live",
    xkt: "Aula de Biking",
    sqzb: "Solicitar Live",
    bczbzt: "Tema desta Live",
    srzt: "Digite o tema",
    bczbjj: "Introdução desta Live",
    kbsj: "Horário de Início",
    xzrisj: "Selecionar Data e Hora",
    tishi: "Aviso",
    dksdzb: "Há 1 live agendada para este horário",
    cxsj: "Duração",
    xzsc: "Selecionar Duração",
    fmt: "Imagem de Capa",
    fmtbnwk: "A imagem de capa não pode estar vazia",
    sc: "Upload",
    yssc: "Máx. 10MB, compacte antes de enviar",
    sccct: "Envie uma imagem com dimensões 360*170",
    tjsq: "Enviar Solicitação",
    tpcj: "Recortar Imagem",
    tzcjwz: "Ajuste a posição do quadro de recorte, selecione a área a manter",
    scdtp: "Imagem Enviada",
    yl: "Prévia (360×170)",
    cjtp: "Recortar Imagem",
    quxiao: "Cancelar",
    qsrzbjj: "Digite a introdução da live",
    qxzrq: "Selecione a data",
    qxzsc: "Selecione a duração",
    kssjdydqsj: "O horário de início deve ser maior que o horário atual",
    sctxtpdx: "O tamanho da imagem de avatar não pode exceder 10MB!",
    tjcg: "Envio Bem-sucedido",
    jkshnr: "Analisaremos o conteúdo da sua solicitação o mais rápido possível",
    hmysqgzb: "Você ainda não solicitou nenhuma live~",
    shz: "Em Análise",
    tongg: "Aprovado",
    jujue: "Rejeitado",
    yugao: "Prévia",
    huifang: "Replay",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/pt_BR.js